import styled from 'styled-components';
import JSONTree from 'core/jsonTree';

import { BaseCell } from './BaseCell';

// using && and an !important to override an !important higher up. :see-no-evil:
const StyledJson = styled(JSONTree)`
  && {
    > .react-json-view {
      padding: 0 !important;
    }
  }
`;

// type CodeCellProps = {
//   collapseAll?: boolean,
//   hideItemCount?: boolean,
//   hideQuotes?: boolean,
//   monospace?: boolean,
//   rootName: string,
//   value: {},
// };

export const createCodeCell =
  (useBaseCell /*: boolean */) =>
  ({
    collapseAll = true,
    hideItemCount = true,
    hideQuotes = true,
    monospace = true,
    rootName = '',
    value,
  }) => {
    const Cell = (
      <StyledJson
        collapseAll={collapseAll}
        hideItemCount={hideItemCount}
        hideQuotes={hideQuotes}
        monospace={monospace}
        rootName={rootName}
        src={value}
      />
    );

    if (useBaseCell) {
      return <BaseCell data-test="code-cell-base-cell">{Cell}</BaseCell>;
    }

    return Cell;
  };

export const CodeCell = createCodeCell(true);
export const CleanCodeCell = createCodeCell(false);
